import { useMantineTheme, Button, Grid, Title, ThemeIcon } from "@mantine/core";
import { Carousel } from '@mantine/carousel';
import {
  IconBrandFirebase,
  IconBrandVue,
  IconSettings,
  IconSock,
  IconSquareRotated,
  IconBrandYoutube,
  IconWorld,
  IconBrandDocker,
  IconBrandMysql,
  IconFlask,
  IconBrandFigma
} from "@tabler/icons";
import Project from "../components/Project";
import BBDCCover from "../images/bbdc-cover.png";
import DinoDollarsCover from "../images/dinodollars-cover.png"
import CineFilmsCover from "../images/cinefilms-cover.png"

function Projects() {
  const theme = useMantineTheme();

  return (
    <Grid ta="start" grow>
      <Grid.Col span={12} mb="lg">
        <Title order={1} variant="gradient" size={50}>
          Notable Projects
        </Title>
      </Grid.Col>

      <Grid.Col style={{ maxWidth: 315 }} sm={4} xs={6}>
        <Project
          title="Bukit Better Driving Centre Website"
          description="A redesigned rendition of the Bukit Batok Driving Centre website done as a team school project. The project mainly focuses on improving the booking functionality of BBDC website to enhance users' experience. "
          picture={BBDCCover}
          icon1name="Vue"
          icon2name="Firebase"
          icon3name="Quasar"
          icon4name="GSAP"
          icon5name="Netlify"
          builticon1={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconBrandVue size={20} />
            </ThemeIcon>
          }
          builticon2={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconBrandFirebase size={20} />
            </ThemeIcon>
          }
          builticon3={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconSettings size={20} />
            </ThemeIcon>
          }
          builticon4={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconSock size={20} />
            </ThemeIcon>
          }
          builticon5={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconSquareRotated size={20} />
            </ThemeIcon>
          }
          showcase1={
            <Button
              leftIcon={<IconBrandYoutube />}
              variant="outline"
              color="gray"
              component="a"
              href="https://www.youtube.com/watch?v=8TnJ-BvkvGo&ab_channel=daryl"
              target="_blank"
              radius="lg"
            >
              Video Showcase
            </Button>
          }
          showcase2={
            <Button
              leftIcon={<IconWorld />}
              variant="outline"
              color="gray"
              component="a"
              href="https://bukitbetterdrivingcenter.netlify.app/"
              target="_blank"
              radius="lg"
            >
              Website
            </Button>
          }
        />
      </Grid.Col>

      <Grid.Col style={{ maxWidth: 315 }} sm={4} xs={6}>
        <Project
          title="Dino Dollars Vouchers Website"
          description="An team project app that links to users' favourite shopping websites. Purchasing products with this link enabled allows users to collect Dino Points and redeem discount vouchers."
          picture={DinoDollarsCover}
          icon1name="Vue"
          icon2name="Docker"
          icon3name="MySQL"
          icon4name="Flask"
          // icon5name="Netlify"
          builticon1={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconBrandVue size={20} />
            </ThemeIcon>
          }
          builticon2={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconBrandDocker size={20} />
            </ThemeIcon>
          }
          builticon3={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconBrandMysql size={20} />
            </ThemeIcon>
          }
          builticon4={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconFlask size={20} />
            </ThemeIcon>
          }
          // builticon5={
          //   <ThemeIcon radius={25} size={35} variant="outline" color="gray">
          //     <IconSquareRotated size={20} />
          //   </ThemeIcon>
          // }
          showcase1={
            <Button
              leftIcon={<IconBrandYoutube />}
              variant="outline"
              color="gray"
              component="a"
              href="https://www.youtube.com/watch?v=8TnJ-BvkvGo&ab_channel=daryl"
              target="_blank"
              radius="lg"
            >
              Video Showcase
            </Button>
          }
          // showcase2={
          //   <Button
          //     leftIcon={<IconWorld />}
          //     variant="outline"
          //     color="gray"
          //     component="a"
          //     href="https://bukitbetterdrivingcenter.netlify.app/"
          //     target="_blank"
          //     radius="lg"
          //   >
          //     Website
          //   </Button>
          // }
        />
      </Grid.Col>

      <Grid.Col style={{ maxWidth: 315 }} sm={4} xs={6}>
        <Project
          title="Cinefilms Movie App"
          description="Built for Coursera's UX design certification course with the goal of helping movie lovers conveniently check and book tickets for upcoming movies"
          picture={CineFilmsCover}
          icon1name="Figma"
          // icon2name="Docker"
          // icon3name="MySQL"
          // icon4name="Flask"
          // icon5name="Netlify"
          builticon1={
            <ThemeIcon radius={25} size={35} variant="outline" color="gray">
              <IconBrandFigma size={20} />
            </ThemeIcon>
          }
          // builticon2={
          //   <ThemeIcon radius={25} size={35} variant="outline" color="gray">
          //     <IconBrandDocker size={20} />
          //   </ThemeIcon>
          // }
          // builticon3={
          //   <ThemeIcon radius={25} size={35} variant="outline" color="gray">
          //     <IconBrandMysql size={20} />
          //   </ThemeIcon>
          // }
          // builticon4={
          //   <ThemeIcon radius={25} size={35} variant="outline" color="gray">
          //     <IconFlask size={20} />
          //   </ThemeIcon>
          // }
          // builticon5={
          //   <ThemeIcon radius={25} size={35} variant="outline" color="gray">
          //     <IconSquareRotated size={20} />
          //   </ThemeIcon>
          // }
          // showcase1={
          //   <Button
          //     leftIcon={<IconBrandYoutube />}
          //     variant="outline"
          //     color="gray"
          //     component="a"
          //     href="https://www.youtube.com/watch?v=8TnJ-BvkvGo&ab_channel=daryl"
          //     target="_blank"
          //     radius="lg"
          //   >
          //     Video Showcase
          //   </Button>
          // }
          showcase1={
            <Button
              leftIcon={<IconWorld />}
              variant="outline"
              color="gray"
              component="a"
              href="https://www.figma.com/file/e1KcNjJU9Qplh3dZvjPg6b/Google-UX-Course?type=design&node-id=74%3A1127&mode=design&t=DtVUxTxiOATeDNPS-1"
              target="_blank"
              radius="lg"
            >
              Figma
            </Button>
          }
        />
      </Grid.Col>
    </Grid>
    
  );
}

export default Projects;
